"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrumblistDemo = void 0;
var React = __importStar(require("react"));
var lodash_1 = __importDefault(require("lodash"));
var Select_1 = require("../Select");
var _1 = require("./");
var CrumblistDemo = /** @class */ (function (_super) {
    __extends(CrumblistDemo, _super);
    function CrumblistDemo(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            options1: [
                { displayText: 'Minneapolis', name: '1', displayOrder: 1 },
                { displayText: 'New York', name: '2', displayOrder: 2 },
                { displayText: 'Lincolnshire', name: '3', displayOrder: 3 },
                { displayText: 'Singapore', name: '4', displayOrder: 4 },
                { displayText: 'Poland', name: '5', displayOrder: 5 },
            ],
            selected1: [
                { displayText: 'Minneapolis', name: '1', displayOrder: 1 },
                { displayText: 'New York', name: '2', displayOrder: 2 },
            ],
            selected2: [
                { displayText: 'Minneapolis', name: '1', displayOrder: 1 },
                { displayText: 'New York', name: '2', displayOrder: 2 },
            ],
            options2: [
                { displayText: 'Minneapolis', name: '1', displayOrder: 1, disabled: true },
                { displayText: 'New York', name: '2', displayOrder: 2 },
                { displayText: 'Lincolnshire', name: '3', displayOrder: 3 },
                { displayText: 'Singapore', name: '4', displayOrder: 4 },
                { displayText: 'Poland', name: '5', displayOrder: 5 },
            ],
            selected3: [
                { displayText: 'Minneapolis', value: '1', isDismissible: false, sequence: 1 },
                { displayText: 'New York', value: '2', isDismissible: true, sequence: 2 },
            ],
            crumbcount: [
                { displayText: 'Minneapolis', value: '1', isDismissible: false, count: 120 },
                { displayText: 'New York', value: '2', isDismissible: true, count: 50 },
            ],
            crumbicon: [
                { displayText: 'Minneapolis', value: '1', isDismissible: false, icon: 'filter' },
                { displayText: 'New York', value: '2', isDismissible: true, count: 50, icon: 'hierarchy' },
            ],
        };
        _this.update1 = _this.update1.bind(_this);
        _this.update2 = _this.update2.bind(_this);
        _this.update3 = _this.update3.bind(_this);
        _this.crumblistUpdate = _this.crumblistUpdate.bind(_this);
        _this.crumblistUpdate3 = _this.crumblistUpdate3.bind(_this);
        return _this;
    }
    CrumblistDemo.prototype.render = function () {
        var _a = this.state, options1 = _a.options1, selected1 = _a.selected1, selected2 = _a.selected2, options2 = _a.options2, selected3 = _a.selected3, crumbcount = _a.crumbcount, crumbicon = _a.crumbicon;
        var crumbDataMaps = [
            { propertyName: 'displayText', crumbPropertyName: 'displayText' },
            { propertyName: 'name', crumbPropertyName: 'value' },
            { propertyName: 'displayOrder', crumbPropertyName: 'sequence' },
        ];
        return (React.createElement("div", null,
            React.createElement("h2", null, "Crumblist"),
            React.createElement("p", null, "The crumblist can accept any kind of data, as long as a data map is provided for displayText and value."),
            React.createElement("pre", null,
                "ICrumbProps",
                React.createElement("br", null),
                "displayText: string;",
                React.createElement("br", null),
                "value: any;",
                React.createElement("br", null),
                "sequence?: number;",
                React.createElement("br", null),
                "isDismissible?: boolean;",
                React.createElement("br", null),
                "count?: number;",
                React.createElement("br", null),
                "icon?: any;",
                React.createElement("br", null),
                React.createElement("br", null),
                "ICrumbMap",
                React.createElement("br", null),
                "propertyName: string;",
                React.createElement("br", null),
                "crumbPropertyName: 'displayText' | 'value' | 'sequence' | 'isDismissible' | 'count' | 'icon' ;",
                React.createElement("br", null),
                React.createElement("br", null),
                "Example:",
                React.createElement("br", null),
                "const SelectOptionCrumbMaps: ICrumbMap[] = [",
                React.createElement("br", null),
                "\u00A0\u00A0{ propertyName: 'displayText', crumbPropertyName: 'displayText' },",
                React.createElement("br", null),
                "\u00A0\u00A0{ propertyName: 'name', crumbPropertyName: 'value' },",
                React.createElement("br", null),
                "\u00A0\u00A0{ propertyName: 'displayOrder', crumbPropertyName: 'sequence' },",
                React.createElement("br", null),
                "];",
                React.createElement("br", null)),
            React.createElement("h5", null, "With Multi-Select"),
            React.createElement(Select_1.Select, { displayText: 'Column', items: options1, selectedValues: lodash_1.default.map(selected1, function (i) { return i.name; }), multiple: true, showCount: true, onApply: this.update1, size: 'md', selectSize: 'md', dropdownSize: 'lg' }),
            React.createElement("div", { style: { marginTop: '5px' } },
                React.createElement(_1.Crumblist, { data: selected1, dataMaps: crumbDataMaps, enableDismiss: true, update: this.crumblistUpdate })),
            React.createElement("p", { className: 'demo' }, "Example Code"),
            React.createElement("pre", null,
                React.createElement("code", null,
                    "<Crumblist",
                    React.createElement("br", null),
                    "\u00A0\u00A0\u00A0\u00A0data={selected1}",
                    React.createElement("br", null),
                    "\u00A0\u00A0\u00A0\u00A0enableDismiss={true}",
                    React.createElement("br", null),
                    "\u00A0\u00A0\u00A0\u00A0update={callback} />",
                    React.createElement("br", null))),
            React.createElement("h5", null, "With Multi-Select (not dismissible)"),
            React.createElement(Select_1.Select, { displayText: 'Column', items: options1, selectedValues: lodash_1.default.map(selected2, function (i) { return i.name; }), multiple: true, showCount: true, onApply: this.update2, size: 'md', selectSize: 'md', dropdownSize: 'lg' }),
            React.createElement("div", { style: { marginTop: '5px' } },
                React.createElement(_1.Crumblist, { data: selected2, dataMaps: crumbDataMaps, enableDismiss: false })),
            React.createElement("p", { className: 'demo' }, "Example Code"),
            React.createElement("pre", null,
                React.createElement("code", null,
                    "<Crumblist",
                    React.createElement("br", null),
                    "\u00A0\u00A0\u00A0\u00A0data={selected1}",
                    React.createElement("br", null),
                    "\u00A0\u00A0\u00A0\u00A0enableDismiss={false}",
                    React.createElement("br", null),
                    " />",
                    React.createElement("br", null))),
            React.createElement("h5", null, "With Disabled Items"),
            React.createElement(Select_1.Select, { displayText: 'Column', items: options2, selectedValues: lodash_1.default.map(selected3, function (i) { return i.value; }), multiple: true, showCount: true, onApply: this.update3, size: 'md', selectSize: 'md', dropdownSize: 'lg' }),
            React.createElement("div", { style: { marginTop: '5px' } },
                React.createElement(_1.Crumblist, { data: selected3, update: this.crumblistUpdate3, enableDismiss: true })),
            React.createElement("p", { className: 'demo' }, "Example Code"),
            React.createElement("pre", null,
                React.createElement("code", null,
                    "<Crumblist",
                    React.createElement("br", null),
                    "\u00A0\u00A0\u00A0\u00A0data={selected3}",
                    React.createElement("br", null),
                    "\u00A0\u00A0\u00A0\u00A0enableDismiss={true}",
                    React.createElement("br", null),
                    "\u00A0\u00A0\u00A0\u00A0update={callback} />",
                    React.createElement("br", null))),
            React.createElement("h5", null, "With Counter Pill"),
            React.createElement("div", { style: { marginTop: '5px' } },
                React.createElement(_1.Crumblist, { data: crumbcount })),
            React.createElement("p", { className: 'demo' }, "Example Code"),
            React.createElement("pre", null,
                React.createElement("code", null,
                    "<Crumblist",
                    React.createElement("br", null),
                    "\u00A0\u00A0\u00A0\u00A0data= [",
                    React.createElement("br", null),
                    "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0{displayText: 'Minneapolis', value: '1', isDismissible: false, count: 120}",
                    React.createElement("br", null),
                    "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0{displayText: 'New York', value: '2', isDismissible: true, count: 50}, ",
                    React.createElement("br", null),
                    "] />",
                    React.createElement("br", null))),
            React.createElement("h5", null, "With Icon"),
            React.createElement("div", { style: { marginTop: '5px' } },
                React.createElement(_1.Crumblist, { data: crumbicon })),
            React.createElement("p", { className: 'demo' }, "Example Code"),
            React.createElement("pre", null,
                React.createElement("code", null,
                    "<Crumblist",
                    React.createElement("br", null),
                    "\u00A0\u00A0\u00A0\u00A0data= [",
                    React.createElement("br", null),
                    "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0{displayText: 'Minneapolis', value: '1', isDismissible: false, icon: 'filter'}",
                    React.createElement("br", null),
                    "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0{displayText: 'New York', value: '2', isDismissible: true, count: 50, icon: 'hierarchy'}, ",
                    React.createElement("br", null),
                    "] />",
                    React.createElement("br", null)))));
    };
    CrumblistDemo.prototype.update1 = function (values, options) {
        var selected = lodash_1.default.filter(options, function (o) { return values.indexOf(o.name) > -1; });
        this.setState({ selected1: selected });
    };
    CrumblistDemo.prototype.update2 = function (values, options) {
        var selected = lodash_1.default.filter(options, function (o) { return values.indexOf(o.name) > -1; });
        this.setState({ selected2: selected });
    };
    CrumblistDemo.prototype.update3 = function (values, options) {
        var selected = lodash_1.default.filter(options, function (o) { return values.indexOf(o.name) > -1; });
        var crumbs = lodash_1.default.map(selected, function (option) { return ({
            value: option.name,
            displayText: option.displayText,
            sequence: option.displayOrder,
            isDismissible: option.disabled !== true,
        }); });
        this.setState({ selected3: crumbs });
    };
    CrumblistDemo.prototype.crumblistUpdate = function (selected) {
        this.setState({ selected1: selected });
    };
    CrumblistDemo.prototype.crumblistUpdate3 = function (selected) {
        this.setState({ selected3: selected });
    };
    return CrumblistDemo;
}(React.Component));
exports.CrumblistDemo = CrumblistDemo;
